<template>
  <div class="about">
    <page-header :title="$t('club.create')" :desc="model.name">
      <li class="breadcrumb-item"><router-link :to="{name:'clubs.index'}">{{$tc('club.name', 2)}}</router-link></li>
      <li class="breadcrumb-item">{{$t('action.createNew')}}</li>
    </page-header>
    <page-content>
      <form @submit.prevent="onSubmit()">
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
          <button class="btn btn-success push-15" data-testid="club-save">{{$t('save')}}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import ClubService from '@/services/club.service'
import clubShortNameMixin from '@/mixins/club.short-name.mixin'
import router from '@/router'

export default {
  mixins: [clubShortNameMixin],
  data () {
    return {
      form: {},
      model: { name: '', shortName: '' },
      fields: fields
    }
  },
  methods: {
    onSubmit () {
      ClubService.store(this.model).then((response) => {
        router.push({ name: 'clubs.index' })
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
